import React from "react";
import { Link } from "react-router-dom";

function ContactPage() {
    return (
        <div className="container py-4">
            <h1 className="h4 mb-4">Kontakt</h1>

            <div className="row g-4 align-items-stretch">
                {/* ľavý vizuál s drevom + logo */}
                <div className="col-md-5">
                    <div className="card h-100 overflow-hidden contact-wood d-flex align-items-end">
                        <div className="bg-white/75 w-100 p-4">
                            <div className="d-flex align-items-center gap-3">
                                <img src="/LOGO.jpg" width="56" height="56" alt="MC Wooddesign" />
                                <div>
                                    <div className="fw-bold">MČ WOODDESIGN</div>
                                    <div className="text-muted small">výroba drevených dekorácií</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* pravý blok s údajmi */}
                <div className="col-md-7">
                    <div className="card h-100">
                        <div className="card-body">
                            <ul className="list-unstyled mb-0">
                                <li className="mb-3">
                                    <i className="bi bi-geo-alt me-2 text-primary"></i>
                                    <strong>Adresa:</strong> Bzovik 156, 962 41 Bzovik
                                </li>
                                <li className="mb-3">
                                    <i className="bi bi-telephone me-2 text-primary"></i>
                                    <strong>Tel. číslo:</strong>{" "}
                                    <a href="tel:+421915322125">+421 915 322 125</a>
                                </li>
                                <li className="mb-3">
                                    <i className="bi bi-envelope me-2 text-primary"></i>
                                    <strong>E-mail:</strong>{" "}
                                    <a href="mailto:martin.ciak8@gmail.com">martin.ciak8@gmail.com</a>
                                </li>
                                <li className="mb-3">
                                    <i className="bi bi-instagram me-2 text-primary"></i>
                                    <strong>Instagram:</strong>{" "}
                                    <a href="https://instagram.com/_mcwooddesign_" target="_blank" rel="noreferrer">
                                        _mcwooddesign_
                                    </a>
                                </li>
                                <li>
                                    <i className="bi bi-facebook me-2 text-primary"></i>
                                    <strong>Facebook:</strong>{" "}
                                    <a href="https://www.facebook.com/p/MČ-Wooddesign-61557183156327" target="_blank" rel="noreferrer">
                                        MČ Wooddesign
                                    </a>
                                </li>
                            </ul>

                            <div className="mt-4 d-flex gap-2">
                                <a
                                    className="btn btn-brown"
                                    href="https://maps.google.com/?q=Bzovik+156,+96241+Bzovik"
                                    target="_blank" rel="noreferrer"
                                >
                                    Zobraziť na mape
                                </a>
                                <Link to="/ponuka" className="btn btn-outline-secondary rounded-pill">Naša ponuka</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ContactPage;
